<template>
  <div class="search-bar" @keyup.13.prevent="filter">
    <div class="padding-x">
      <div class="columns is-multiline  is-desktop is-mobile">

        <column v-if="getWidth === 'lg'"  size="is-half-mobile is-6-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
        </column>
        <column size="is-12-mobile is-12-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
          <div class="is-grouped">
            <p class="control is-expanded has-icons-left">
              <input v-model="keyword" class="input" type="search" placeholder="Keyword">
              <span class="icon is-small is-left">
                <i class="fas fa-search"></i>
              </span>
            </p>
          </div>
        </column>
        <column size="is-half-mobile is-6-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
          <div class="is-grouped">
            <p class="control is-expanded has-icons-left">
              <input v-model="locations" class="input" type="search" placeholder="Location">
              <span class="icon is-small is-left">
            <i class="fas fa-map-marker-alt"></i>
          </span>
            </p>
          </div></column>
        <column size="is-half-mobile is-6-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
          <div class="is-grouped">
            <div class="control is-expanded">
              <div  class="width-100 select">
                <select class="width-100" v-model="jobCategory" @change.prevent="filter">
                  <option value="">{{this.$t('widget.allEmploymentTypes')}}</option>
                  <option v-for="type in companyCategories" :value="type.name" :key="type.id">{{type.name}}</option>
                </select>
              </div>
            </div>
          </div>
        </column>
        <column v-if="getWidth === 'xs'"  size="is-12-mobile is-12-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
          <button class="is-primary button is-fullwidth" @click="filter">Search</button>
        </column>
        <column  size="is-half-mobile is-6-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
        </column>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import SearchCategories from './categories'
import Column from '@/components/general/column'
import CompaniesAutocomplete from '../../companies/companies-autocomplete'
import {ecoSystemOptions, jobCategoryOptions} from '@/constants/array-constants'

export default {
  data () {
    return {
      jobCategories: jobCategoryOptions,
      ecoCategories: ecoSystemOptions,
      keyword: '',
      locations: '',
      jobCategory: '',
      ecoSystem: '',
      windowWidth: 0,
      category: []
    }
  },
  components: {SearchCategories, Column, CompaniesAutocomplete},

  computed: {
    ...mapState('domain', ['jobTypes']),
    ...mapState('companies', ['companyCategories']),
    q () {
      const q = this.$route.meta.stacks ? 'stacks' : null
      return this.$route.query.q || q
    },
    getWidth () {
      if (this.windowWidth <= 760) {
        return 'xs'
      } else if (this.windowWidth <= 1218) {
        return 'md'
      }
      return 'lg'
    },
    getEcoClass () {
      return this.ecoSystem ? 'control is-expanded has-icons-left' : 'control is-expanded'
    },
    selectedCategory: {
      get () { return this.category },
      set (value) {
        this.getCompanies(this.getFilters())
        this.category = value
      }
    }
  },
  methods: {
    ...mapActions('jobs', ['search']),
    ...mapActions('domain', ['fetchJobTypes']),
    ...mapActions('companies', [
      'getCompanies'
    ]),
    ...mapActions('jobseekers', ['getFilterJobSeekers']),
    onChange (jobCategory) {
      this.ecoSystem = jobCategory
      this.filter()
    },
    getImgUrl (imageName) {
      const images = require.context('../../../assets/', false, /\.png$/)
      return images('./' + imageName + '.png')
    },
    getFilters () {
      return {
        keyword: this.keyword !== null ? this.keyword.trim() : '',
        location: this.locations !== null ? this.locations.trim() : '',
        jobCategory: this.jobCategory,
        ecoSystem: this.ecoSystem
      }
    },
    async filter () {
      await this.getCompanies(this.getFilters())
    }
  },
  watch: {
    keyword (newValue) {
      if (newValue.trim() === '') {
        this.filter()
      }
    },
    locations (newValue) {
      if (newValue.trim() === '') {
        this.filter()
      }
    }
  },
  mounted () {
    this.keyword = this.q
    this.windowWidth = window.innerWidth
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  }
}
</script>

<style lang="scss" scoped>
.search-bar {
  background: #fff;
  width: 101%;
  padding: 14px 0 16px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: -24px;
  border-bottom: 1px solid #ddd;

  .filter-wpr {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0 auto;
    width: 80%;
    .field {
      width: 25%;
      .select {
        width: 100%;
        select {
          width: 100%;
        }
      }
    }
    .field:not(:last-child) {
      margin-right: 24px;
      margin-bottom: 0;
    }

    .control.has-icons-left .icon, .control.has-icons-right .icon {
      height: 40px;
      width: 2.75em;
    }

    .control.has-icons-left .input:focus ~ .icon, .control.has-icons-left .select:focus ~ .icon, .control.has-icons-right .input:focus ~ .icon, .control.has-icons-right .select:focus ~ .icon {
      color: #111;
    }
    .control {
      margin-top: 0;
    }
  }
  .width-100{
    width: 100%;
  }
  .padding-x{
    padding-left: 30px;
    padding-right: 36px;
  }
  .mt-4{
    margin-top: 4px
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/search-companies/index.vue